import React from 'react';
import './pageErr.scss';

function PageErr() {
  return (
    <div className="err-page">
      <h2>404</h2>
      <p>Page not found</p>
    </div>
  );
}

export default PageErr;
